export default __webpack_public_path__ + "static/media/comp5.ba55a121.webp";